// Effect 1 — Hitstop / freeze-frame. Nijman's most underrated: freeze everything ~40–80ms on
// impact and weight appears out of nowhere. It pauses the shared clock (so every tween freezes
// together) and adds a body class that halts CSS animations for the same window.
import { feel } from "../feel";
import { freeze } from "../anim";
import { registerEffect } from "../registry";
import { intensity, timed } from "../../tuner/scale";

export function registerHitstop(): void {
  registerEffect(
    { name: "hitstop", label: "1 · Hitstop" },
    "word:valid",
    () => {
      const ms = timed(feel.hitstop.ms * intensity(feel.hitstop)); // intensity scales freeze length; juice speed scales time
      freeze(ms);
      document.body.classList.add("hitstop");
      window.setTimeout(() => document.body.classList.remove("hitstop"), ms);
    },
  );
}
